export default class TelecomDto {
    constructor(obj) {
        this.id = obj.id
        this.code = obj.id
        this.reference = obj.reference
        this.telecomType = obj.telecomType
        this.materielType = obj.telecomType
        this.serialNumber = obj.serialNumber
        this.imei = obj.imei
        this.comment = obj.comment
        this.openDate = obj.openDate
        this.closeDate = obj.closeDate
        this.closeCause = obj.closeCause
        this.lineNumber = obj.lineNumber
        this.providerId = obj.providerId
        this.updateDate = obj.updateDate
        this.updateLogin = obj.updateLogin
        this.loginReferent = obj.loginReferent
        this.manufacturerId = obj.manufacturerId
        this.transmissionVolume = obj.transmissionVolume
        this.administrator = obj.administrator
        this.purchaseDate = obj.purchaseDate
        this.networkCode = obj.networkCode
        this.digitalLine = obj.digitalLine
        this.telecomMode = obj.telecomMode
        this.powerSupplyType = obj.powerSupplyType
        this.pileNumber = obj.pileNumber
        this.supplyTime = obj.supplyTime
        this.desiccant = obj.desiccant
        this.warrantyTime = obj.warrantyTime
        this.withdrawalDate = obj.withdrawalDate
        this.replacementDate = obj.replacementDate
        this.jobExecutionId = obj.jobExecutionId
        this.isEquipment = obj.isEquipment
    }
}
